import React from 'react';
import Cookies from 'universal-cookie';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {
  InputSpinner,
  PriceBreak,
  AddToBasketButton,
  ViewBasketButton,
  CheckStockModal,
  PartsListModal,
} from '../../components';
import { CheckProductSensitivity, GetCustomerSpecificPriceBreaks } from '../../../../shared/services';
import Modal from '../../components/Modal/Modal';

export default class InputSpinnerContainer extends React.Component {
  constructor(props) {
    super(props);
    const rsWebProductModel = window.rs.web.product.model;
    this.state = {
      contextPath: rsWebProductModel.contextPath,
      productNumber: rsWebProductModel.productNumber,
      stockNumber: rsWebProductModel.stockNumber,
      productId: rsWebProductModel.productId,
      initialQuantity: rsWebProductModel.initialQuantity,
      packSize: rsWebProductModel.packSize,
      maximumQuantity: rsWebProductModel.maximumQuantity,
      colSize: rsWebProductModel.colSize,
      labels: rsWebProductModel.labels,
      showIndicativePrices: rsWebProductModel.showIndicativePrices,
      priceBreaks: rsWebProductModel.priceBreaks,
      quantity: rsWebProductModel.initialQuantity,
      wasPrice: rsWebProductModel.wasPrice,
      productPrice: rsWebProductModel.productPrice,
      isCustomerSpecificPricing: false,
      hasAddedToBasket: false,
      basketUrl: rsWebProductModel.basketUrl,
      showRealTimeQuantityChecker: rsWebProductModel.showRealTimeQuantityChecker,
      saveToPartsListLinkUrl: rsWebProductModel.saveToPartsListLinkUrl,
      name: rsWebProductModel.name,
      manufacturerPartNumber: rsWebProductModel.manufacturerPartNumber,
      energyEfficiencyRating: rsWebProductModel.energyEfficiencyRating,
      energyProductInfoSheet: rsWebProductModel.energyProductInfoSheet,
      energyEfficiencyRatingText: rsWebProductModel.energyEfficiencyRatingText,
      energyEfficiencyImage: rsWebProductModel.energyEfficiencyImage,
      restrictions: {
        restricted: false,
        barred: false,
        hasRestrictions() {
          return this.restricted || this.barred;
        },
      },
      customerDisplayText: '',
      infoText: '',
      showCheckStockModal: false,
      displayPackSizeWarning: false,
      showPartsListModal: rsWebProductModel.partsList.popupPartsList,
      restrictBackOrder: rsWebProductModel.restrictBackOrder,
      promiseCannotBackOrder: rsWebProductModel.promiseCannotBackOrder,
      promiseQuantity: rsWebProductModel.promiseQuantity,
      promiseNoAddToCart: rsWebProductModel.promiseNoAddToCart,
    };

    this.handlePartsListClick = this.handlePartsListClick.bind(this);
    this.closeCheckStockModal = this.closeCheckStockModal.bind(this);
    this.closePartsListModal = this.closePartsListModal.bind(this);
    this.sendAddBeacon = this.sendAddBeacon.bind(this);
    this.modalAddedToBasketFunc = this.modalAddedToBasketFunc.bind(this);
  }

  componentWillMount() {
    const cookies = new Cookies();
    const isloggedInCookie = cookies.get('loginStatus');

    const loginStatusListForCustomerSpecificPricing = ['5', '6', '14', '22'];

    const customerSpecificPricing = (loginStatusListForCustomerSpecificPricing.indexOf(isloggedInCookie) > -1);

    if (isloggedInCookie && customerSpecificPricing) {
      GetCustomerSpecificPriceBreaks(this.state.productNumber, this.state.priceBreaks).then(json => {
        if (json && json.length > 0) this.setState({ priceBreaks: json, isCustomerSpecificPricing: true });
      }, () => {
        // At the moment the error will be swallowed but a error handling strategy is being considered
      });
    }

    if (isloggedInCookie && (parseInt(isloggedInCookie, 0) >= 10 && parseInt(isloggedInCookie, 0) <= 22)) {
      CheckProductSensitivity(this.state.productId, this.state.stockNumber).then(json => {
        if (json && json.restriction) {
          this.setState(prevState => ({
            restrictions: {
              ...prevState.restrictions, restricted: json.restriction === 'restricted', barred: json.restriction === 'barred',
            },
            customerDisplayText: json.customerDisplayText,
            infoText: json.infoText,
          }));
        }
      }, () => {

      });
    }
  }

  quantityUpdated(newQuantity) {
    this.setState({
      quantity: newQuantity,
      displayPackSizeWarning: false,
    });
  }

  displayPackSizeWarning() {
    this.setState({
      displayPackSizeWarning: true,
    });
  }

  sendAddBeacon(itemQuantity) {
    function getPriceBreak(priceBreaks, qty) {
      const matchingPrice = priceBreaks.find(p => (p.priceBreakLowerBound <= qty &&
          ((!(p.priceBreakUpperBound)) || (p.priceBreakUpperBound >= qty))));
      if (matchingPrice) return matchingPrice.priceExVatWithoutCurrencySymbol;
      console.log(`No matching pricebreak for qty ${qty}`);
      return priceBreaks[0].priceExVatWithoutCurrencySymbol;
    }

    // Send search beacon
    window.getGbTracker().sendAddToCartEvent({
      id: RS.Utils.Cookies.getCookie('cart'), // XXX This won't work if cart has not been initialized
      items: [
        {
          productId: this.state.productNumber,
          title: this.state.name,
          price: getPriceBreak(this.state.priceBreaks, this.state.quantity),
          currency: this.state.productPrice.currencyCode,
          quantity: itemQuantity,
          // eslint-disable-next-line no-underscore-dangle
          collection: window.getGbTracker().__getInternals().AREA, // Not sure if there is a better way of getting this
          category: '', // TODO Something like 'AA rechargeable batteries' - get from breadcrumb because not in state?
          sku: this.state.manufacturerPartNumber,
        },
      ],
      experiments: [],
    });
  }

  modalAddedToBasketFunc() {
    const self = this;
    return function (qty) {
      return self.sendAddBeacon(qty);
    };
  }

  addedToBasket() {
    this.setState({
      hasAddedToBasket: true,
      displayPackSizeWarning: false,
    });
    this.sendAddBeacon(this.state.quantity);
  }

  closeCheckStockModal() {
    this.setState({
      showCheckStockModal: false,
    });
  }

  multiplesWarningFormatted() {
    return this.state.labels.multiplesWarning.replace(/##SSM##/g, this.state.packSize);
  }

  handlePartsListClick() {
    if (this.state.saveToPartsListLinkUrl) {
      window.location.assign(this.state.saveToPartsListLinkUrl);
    } else {
      this.setState({
        showPartsListModal: true,
      });
    }
  }

  closePartsListModal() {
    this.setState({
      showPartsListModal: false,
    });
  }

  render() {
    const { showCheckStockModal, showPartsListModal } = this.state;

    return (
      <div>
        <PriceBreak
          colSize={this.state.colSize}
          labels={this.state.labels}
          showIndicativePrices={this.state.showIndicativePrices}
          priceBreaks={this.state.priceBreaks}
          quantity={this.state.quantity}
          packSize={this.state.packSize}
          productPrice={this.state.productPrice}
          isCustomerSpecificPricing={this.state.isCustomerSpecificPricing}
          energyEfficiencyRating={this.state.energyEfficiencyRating}
          energyProductInfoSheet={this.state.energyProductInfoSheet}
          energyEfficiencyRatingText={this.state.energyEfficiencyRatingText}
          energyEfficiencyImage={this.state.energyEfficiencyImage}
        />
        <div className="addToCartRTQContainer">
          { this.state.restrictions.hasRestrictions() &&
          <div className="product-restrictions-container">
            <div className="customer-display-text">{this.state.customerDisplayText}</div>
            <div className="info-text">{this.state.infoText}</div>
          </div>}
          { !this.state.restrictions.barred &&
          <React.Fragment>
            {this.state.displayPackSizeWarning &&
              <div className={'quantity-warning-container'}>
                <div className={'quantity-warning-text'}>{this.multiplesWarningFormatted()}</div>
              </div>
            }
            <div className="priceQuantity">
              <InputSpinner
                initialQuantity={this.state.initialQuantity}
                packSize={this.state.packSize}
                maximumQuantity={this.state.maximumQuantity}
                onUpdateQuantity={quantity => this.quantityUpdated(quantity)}
              />
              <div className="text-units">{this.state.labels.rangeHeaderLabel}</div>
              <div className={'add-to-basket-container'}>
                <AddToBasketButton
                  label={this.state.labels.addToCart}
                  stockNumber={this.state.stockNumber}
                  quantity={this.state.quantity}
                  onAddedToBasket={() => this.addedToBasket()}
                  packSize={this.state.packSize}
                  onPackSizeError={() => this.displayPackSizeWarning()}
                  disabled={this.state.restrictBackOrder ||
                    this.state.promiseNoAddToCart || (this.state.promiseCannotBackOrder && this.state.quantity > this.state.promiseQuantity)}
                />
              </div>
              {this.state.hasAddedToBasket && <div className="cart-added page-cart-added">
                <i className="icon icon-rs_57-tick" aria-hidden="true" />
                <span>{this.state.labels.addedToCart}</span>
                <ViewBasketButton
                  label={this.state.labels.viewBasket}
                  redirectUrl={this.state.basketUrl}
                />
              </div>}
              <div className="ck-lead-time">
                <div className="float-left ck-stock-container">
                  {this.state.showRealTimeQuantityChecker &&
                  <div>
                    <a
                      className="check-stock-level-link"
                      role="button"
                      onClick={() => {
                        this.setState({
                          showCheckStockModal: !showCheckStockModal,
                        });
                      }}
                      tabIndex={-1}
                      disabled={this.state.promiseNoAddToCart}
                    >{this.state.labels.realTimeQuantityChecker}</a>
                    <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                      {showCheckStockModal && <Modal
                        key={1}
                        header="My Modal"
                        open={showCheckStockModal}
                        onClose={this.closeCheckStockModal}
                        showFooter={false}
                        title={this.state.labels.checkStock.modalTitle}
                      >
                        <CheckStockModal
                          initialQuantity={this.state.quantity}
                          maximumQuantity={this.state.maximumQuantity}
                          stockNumber={this.state.stockNumber}
                          productNumber={this.state.productNumber}
                          productId={this.state.productId}
                          labels={this.state.labels.checkStock}
                          closeModal={this.closeCheckStockModal}
                          basketUrl={this.state.basketUrl}
                          onAddToBasket={this.modalAddedToBasketFunc()}
                        />
                      </Modal> }
                    </ReactCSSTransitionGroup>
                  </div>}
                </div>
                <div className="float-right save-partslist-container">
                  <a className="save-partslist-link" onClick={this.handlePartsListClick} role="button" tabIndex={-1}>
                    <i className="icon icon-rs_52-star-stroke" />
                    <span>{this.state.labels.addToAPartsList}</span>
                  </a>
                  <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                    {showPartsListModal && <Modal
                      key={1}
                      header="My Modal"
                      open={showPartsListModal}
                      onClose={this.closePartsListModal}
                      showFooter={false}
                      title={this.state.labels.addToAPartsList}
                    >
                      <PartsListModal
                        contextPath={this.state.contextPath}
                        name={this.state.name}
                        manufacturerPartNumber={this.state.manufacturerPartNumber}
                        productNumber={this.state.productNumber}
                        initialQuantity={this.state.initialQuantity}
                        maximumQuantity={this.state.maximumQuantity}
                        stockNumber={this.state.stockNumber}
                        labels={this.state.labels.partsList}
                        closeModal={this.closePartsListModal}
                      />
                    </Modal>}
                  </ReactCSSTransitionGroup>
                </div>
              </div>
            </div>
          </React.Fragment>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/PriceBreak/PriceBreak.js